import { render, staticRenderFns } from "./EmptyEmail.vue?vue&type=template&id=d7c46c72&scoped=true"
import script from "./EmptyEmail.vue?vue&type=script&lang=js"
export * from "./EmptyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c46c72",
  null
  
)

export default component.exports